import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Landing.css';

function Landing() {
  return (
    <div>
      {/* ── Hero ── */}
      <header className="lp-hero">
        <nav className="lp-nav">
          <div className="ps-container">
            <div className="lp-nav__inner">
              <Link to="/" className="lp-logo">
                Postrify <span className="lp-logo-dot" />
              </Link>
              <div className="lp-nav__links">
                <Link to="/login" className="ps-btn ps-btn--ghost">Log in</Link>
                <Link to="/register" className="ps-btn ps-btn--primary">Get started free</Link>
              </div>
            </div>
          </div>
        </nav>

        <div className="ps-container">
          <div className="lp-hero__body">
            <div className="lp-hero__eyebrow">✦ AI-Powered Social Media</div>
            <h1 className="lp-hero__title">
              Create content that<br />
              <span>actually converts</span>
            </h1>
            <p className="lp-hero__subtitle">
              Postrify generates on-brand Instagram posts — images, captions,
              and hashtags — in seconds. Schedule and publish automatically.
            </p>
            <div className="lp-hero__cta">
              <Link to="/register" className="ps-btn ps-btn--primary ps-btn--lg">
                Start free trial →
              </Link>
              <a href="#features" className="lp-btn-light">See how it works</a>
            </div>
          </div>
        </div>
      </header>

      {/* ── Features ── */}
      <section id="features" className="lp-features">
        <div className="ps-container">
          <span className="lp-section-label">Features</span>
          <h2 className="lp-section-title">Everything you need to scale your<br />social media presence</h2>

          <div className="lp-features-grid">
            {[
              { icon: '🤖', title: 'AI Content Generation', desc: 'Generate professional captions, hashtags, and calls-to-action tailored precisely to your brand voice and niche.' },
              { icon: '🎨', title: 'Image Generation', desc: 'Create stunning visual content with 2–3 unique variations per post. Your brand logo is overlaid automatically.' },
              { icon: '📅', title: 'Smart Scheduling', desc: 'Schedule posts in advance and let our system automatically publish them at the optimal time for your audience.' },
              { icon: '🏢', title: 'Multi-Brand Management', desc: 'Manage unlimited brands from one clean dashboard. Perfect for agencies and growing businesses.' },
              { icon: '📱', title: 'Auto-Post to Social', desc: 'Connect Instagram and Facebook. Once scheduled, posts are published automatically — no manual work needed.' },
              { icon: '🎯', title: 'Brand Consistency', desc: 'Maintain your unique tone and avoid content repetition with our AI-powered variety engine.' },
            ].map((f) => (
              <div className="lp-feature-card" key={f.title}>
                <div className="lp-feature-icon">{f.icon}</div>
                <h3>{f.title}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── How It Works ── */}
      <section className="lp-how">
        <div className="ps-container">
          <span className="lp-section-label">How it works</span>
          <h2 className="lp-section-title">Go live in four simple steps</h2>

          <div className="lp-steps">
            {[
              { n: 1, title: 'Configure Your Brand', desc: 'Set your brand name, niche, tone, target audience, and upload your logo.' },
              { n: 2, title: 'Connect Social Accounts', desc: 'Securely connect your Instagram and Facebook accounts with a single click.' },
              { n: 3, title: 'Generate Content', desc: 'Let AI create engaging posts with images, captions, and hashtags tailored to your brand.' },
              { n: 4, title: 'Schedule & Publish', desc: 'Set your posting schedule and let automation handle everything else.' },
            ].map((s) => (
              <div className="lp-step" key={s.n}>
                <div className="lp-step__num">{s.n}</div>
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section className="lp-cta">
        <div className="ps-container">
          <h2>Ready to grow your audience?</h2>
          <p>Join thousands of businesses scaling their social media with AI.</p>
          <Link to="/register" className="ps-btn ps-btn--primary ps-btn--lg">
            Get started — it's free
          </Link>
        </div>
      </section>

      {/* ── Footer ── */}
      <footer className="lp-footer">
        <div className="ps-container">
          <div className="lp-footer__inner">
            <div className="lp-footer__brand">
              Postrify <span className="lp-logo-dot" />
            </div>
            <div className="lp-footer__links">
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/data-deletion">Data Deletion</Link>
            </div>
            <p className="lp-footer__copy">© 2024 Postrify. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Landing;
